@if (!showAsText()) {
  <nz-modal [nzVisible]="isVisible()" nzTitle="Unlock Permium Feature"
            (nzOnCancel)="onCancel()"
            (nzOnOk)="confirmed.emit()"
            [nzWidth]="'600px'"
            [nzOkText]="'Upgrade Now'"
            [nzCancelText]="'Maybe Later'"
            [nzAutofocus]="null">
    <ng-container *nzModalContent>
      <p>This feature is available on <strong>paid plans only.</strong> <span style="color: #65d5f4"> {{lockedFeatureTitle()}} </span>
        {{lockedFeatureDescription()}}
      </p>
    </ng-container>
  </nz-modal>

} @else {
  <div class="text-styles">
    <p>This feature is available on <strong>paid plans only.</strong> <strong style="color: #65d5f4"> {{lockedFeatureTitle()}} </strong>
      {{lockedFeatureDescription()}}
    </p>

    <div class="button">
      <button type="button" (click)="confirmed.emit()" type="button" nz-button nzType="primary" >
        Upgrade Plan
      </button>
    </div>
  </div>

}
